<template>
  <path pid="0" d="M23 3H3a1 1 0 00-.76 1.65L10 13.83V20a1 1 0 00.55.89l4 2A1 1 0 0016 22v-8.17l7.76-9.18A1 1 0 0023 3zm-8.76 9.81a1 1 0 00-.24.65v6.92l-2-1v-5.92a1 1 0 00-.24-.65L5.16 5h15.68z"/>
</template>
